import { Buffer } from 'buffer'

export type PKCECodePair = {
  codeVerifier: string
  codeChallenge: string
  createdAt: Date
}

export const base64URLEncode = (str: Buffer): string => {
  return str
    .toString('base64')
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=/g, '')
}

async function sha256(message: string) {
    const msgBuffer = new TextEncoder().encode(message);
    return await crypto.subtle.digest('SHA-256', msgBuffer);
}

/// Reappropriated from https://github.com/gardner/react-oauth2-pkce to use browser based cryptography
/// as specified https://developer.mozilla.org/en-US/docs/Web/API/Crypto
export const createPKCECodes = async (): Promise<PKCECodePair> => {
    var code = crypto.getRandomValues(new Int8Array(64))    
    const codeVerifier = base64URLEncode(Buffer.from(code));
    const codeChallenge = base64URLEncode(Buffer.from(await sha256(codeVerifier)))
    const createdAt = new Date()
    const codePair = {
        codeVerifier,
        codeChallenge,
        createdAt
    }
    return codePair
}
